export const env = {
    // TIMOLIA_API_URL: 'http://localhost:8000/api'
    // TIMOLIA_API_URL: 'https://dev.www.timolia.de/api'
    //TIMOLIA_API_URL: 'https://www.timolia.de/api'
    TIMOLIA_API_URL: 'https://timolia.de/api'
}
